module.exports = __webpack_public_path__ + "static/img-set-85285284eaf9f0165de34af924a64402.jpg";